import theme from 'assets/themes';
import { Card } from 'components/atoms/Card';
import { Empty } from 'components/atoms/Empty';
import { Tip } from 'components/atoms/Tip';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import instance from 'utils/axios';
import styles from './style.module.scss';
import constants from 'utils/constants';


const MaintenancePage = () => {
  useEffect(() => {
    const container = document.getElementById("bg-container");
    if (!container) return;
    container.style.backgroundImage = `url(${theme["bgImage"]})`;
  }, []);
  const navigate = useNavigate();

  useEffect(() => {
    checkServerStatus();
  }, []);

  const checkServerStatus = async () => {
    try {
      await instance.get('health/database')
      navigate('/dashboard', { replace: true });
    } catch (error) {

    }
  };
  return (
    <div className={`${styles.signup_container} h-screen flex justify-center flex-col `} id="bg-container">
      <div className='flex w-full justify-center items-center mb-8'>
        <img src="/logo.png" alt="IdentityMatrix Logo" width='180px' />
      </div>
      <div className="flex w-full justify-center items-center">
        <Card className="min-h-auto justify-center items-center gap-8 max-w-lg pb-10">
          <Empty type="no-connect" message='We will be back online soon!' title="Identity Matrix" className="!gap-1 mb-8" />
          <div className="h-full w-full flex flex-col sm:gap-2 justify-start items-center text-gray-400 text-base">
            <Tip
              icon="alert-circle-outline"
              title="Server Unavailable"
              description="We're currently unable to connect to the server. Please check your internet connection or try again shortly."
            />
            <Tip icon="mail-check" title="Need Assistance?" description={constants.COMPANY_1_EMAIL_SUPPORT} />
          </div>
        </Card>
      </div>
    </div>
  );
};

export const Maintenance = MaintenancePage;;